import React, {useState} from "react"
import {connect} from "react-redux";

import {selectNewAreaDispatchAction} from "../../../state/geoMap/dispatchActions";
import {getScopeConfigurationFieldsBy, getSyncSearchFormValuesByState} from "../../../helpers/configurationHelper";
import {ConfigurationsType} from "../../../types/configurations";
import {ShapeType} from "../../../types/shape";
import translations from "../../../translations";
import {Button, Form as BootstrapForm, Card} from "react-bootstrap";
import {convertRectangleCoordinatesIntoShape} from "../../../helpers/shapeHelper";
import {Picky} from "react-picky";
import InputText from "../../shared/inputs/InputText";
import BootstrapToggle from "react-bootstrap-toggle";
import {convertDegreesMinutesSecondsToDecimal} from "../../../helpers/coordinatesHelper";
import {SearchResultsType} from "../../../types/product";

interface PropsType {
    configurations: ConfigurationsType,
    selectedArea: ShapeType,
    values: any,
    updatePathCoordinatesActionHandler: any,
    language: string,
    selectNewAreaDispatchActionHandler: any,
    handleCloseModal: any,
    searchByProducts: boolean,
    searchResults: SearchResultsType
}

const SquareAOIHelper = (props: PropsType) => {
    const {
        configurations,
        selectNewAreaDispatchActionHandler,
        language,
        values,
        handleCloseModal,
        searchByProducts,
        searchResults
    } = props;

    const [latUpperLeft, setLatUpperLeft] = useState('');
    const [lngUpperLeft, setLngUpperLeft] = useState('');
    const [typeLatUpperLeft, setTypeLatUpperLeft] = useState(translations('nord', language));
    const [typeLngUpperLeft, setTypeLngUpperLeft] = useState(translations('east', language));

    const [latLowerRight, setLatLowerRight] = useState('');
    const [lngLowerRight, setLngLowerRight] = useState('');
    const [typeLatLowerRight, setTypeLatLowerRight] = useState(translations('nord', language));
    const [typeLngLowerRight, setTypeLngLowerRight] = useState(translations('east', language));


    const [isDecimalDegrees, setIsDecimalDegrees] = useState(true);

    const [degreesXUpperLeft, setDegreesXUpperLeft] = useState('');
    const [minutesXUpperLeft, setMinutesXUpperLeft] = useState('');
    const [secondsXUpperLeft, setSecondsXUpperLeft] = useState('');
    const [degreesYUpperLeft, setDegreesYUpperLeft] = useState('');
    const [minutesYUpperLeft, setMinutesYUpperLeft] = useState('');
    const [secondsYUpperLeft, setSecondsYUpperLeft] = useState('');

    const [degreesXLowerRight, setDegreesXLowerRight] = useState('');
    const [minutesXLowerRight, setMinutesXLowerRight] = useState('');
    const [secondsXLowerRight, setSecondsXLowerRight] = useState('');
    const [degreesYLowerRight, setDegreesYLowerRight] = useState('');
    const [minutesYLowerRight, setMinutesYLowerRight] = useState('');
    const [secondsYLowerRight, setSecondsYLowerRight] = useState('');

    const [typeXUpperLeft, setTypeXUpperLeft] = useState(translations('east', language));
    const [typeYUpperLeft, setTypeYUpperLeft] = useState(translations('nord', language));

    const [typeXLowerRight, setTypeXLowerRight] = useState(translations('east', language));
    const [typeYLowerRight, setTypeYLowerRight] = useState(translations('nord', language));

    const optionsX = [
        translations('ovest', language),
        translations('east', language)
    ];

    const optionsY = [
        translations('nord', language),
        translations('sud', language)
    ];

    const drawSquareHandler = () => {

        let newShape;

        if (!isDecimalDegrees) {
            //upper left
            const latDegreesUpperLeft = typeYUpperLeft === translations('nord', language) ? parseFloat(degreesYUpperLeft.replace(',', '.')) : parseFloat(`-${degreesYUpperLeft.replace(',', '.')}`);
            const latMinutesUpperLeft = typeYUpperLeft === translations('nord', language) ? parseFloat(minutesYUpperLeft.replace(',', '.')) : parseFloat(`-${minutesYUpperLeft.replace(',', '.')}`);
            const latSecondsUpperLeft = typeYUpperLeft === translations('nord', language) ? parseFloat(secondsYUpperLeft.replace(',', '.')) : parseFloat(`-${secondsYUpperLeft.replace(',', '.')}`);

            const lngDegreesUpperLeft = typeXUpperLeft === translations('east', language) ? parseFloat(degreesXUpperLeft.replace(',', '.')) : parseFloat(`-${degreesXUpperLeft.replace(',', '.')}`);
            const lngMinutesUpperLeft = typeXUpperLeft === translations('east', language) ? parseFloat(minutesXUpperLeft.replace(',', '.')) : parseFloat(`-${minutesXUpperLeft.replace(',', '.')}`);
            const lngSecondsUpperLeft = typeXUpperLeft === translations('east', language) ? parseFloat(secondsXUpperLeft.replace(',', '.')) : parseFloat(`-${secondsXUpperLeft.replace(',', '.')}`);

            const newLatUpperLeft = convertDegreesMinutesSecondsToDecimal(+latDegreesUpperLeft, +latMinutesUpperLeft, +latSecondsUpperLeft);
            const newLngUpperLeft = convertDegreesMinutesSecondsToDecimal(+lngDegreesUpperLeft, +lngMinutesUpperLeft, +lngSecondsUpperLeft);

            //lower right
            const latDegreesLowerRight = typeYLowerRight === translations('nord', language) ? parseFloat(degreesYLowerRight.replace(',', '.')) : parseFloat(`-${degreesYLowerRight.replace(',', '.')}`);
            const latMinutesLowerRight = typeYLowerRight === translations('nord', language) ? parseFloat(minutesYLowerRight.replace(',', '.')) : parseFloat(`-${minutesYLowerRight.replace(',', '.')}`);
            const latSecondsLowerRight = typeYLowerRight === translations('nord', language) ? parseFloat(secondsYLowerRight.replace(',', '.')) : parseFloat(`-${secondsYLowerRight.replace(',', '.')}`);

            const lngDegreesLowerRight = typeXLowerRight === translations('east', language) ? parseFloat(degreesXLowerRight.replace(',', '.')) : parseFloat(`-${degreesXLowerRight.replace(',', '.')}`);
            const lngMinutesLowerRight = typeXLowerRight === translations('east', language) ? parseFloat(minutesXLowerRight.replace(',', '.')) : parseFloat(`-${minutesXLowerRight.replace(',', '.')}`);
            const lngSecondsLowerRight = typeXLowerRight === translations('east', language) ? parseFloat(secondsXLowerRight.replace(',', '.')) : parseFloat(`-${secondsXLowerRight.replace(',', '.')}`);

            const newLatLowerRight = convertDegreesMinutesSecondsToDecimal(+latDegreesLowerRight, +latMinutesLowerRight, +latSecondsLowerRight);
            const newLngLowerRight = convertDegreesMinutesSecondsToDecimal(+lngDegreesLowerRight, +lngMinutesLowerRight, +lngSecondsLowerRight);

            newShape = convertRectangleCoordinatesIntoShape(newLngUpperLeft, newLatUpperLeft, newLngLowerRight, newLatLowerRight);
        } else {
            const latUL = `${typeLatUpperLeft === translations('sud', language) ? '-' : ''}${latUpperLeft.replace(',', '.')}`;
            const lngUL = `${typeLngUpperLeft === translations('ovest', language) ? '-' : ''}${lngUpperLeft.replace(',', '.')}`;
            const latLR = `${typeLatLowerRight === translations('sud', language) ? '-' : ''}${latLowerRight.replace(',', '.')}`;
            const lngLR = `${typeLngLowerRight === translations('ovest', language) ? '-' : ''}${lngLowerRight.replace(',', '.')}`;

            newShape = convertRectangleCoordinatesIntoShape(+lngUL, +latUL, +lngLR, +latLR);
        }

        selectNewAreaDispatchActionHandler(configurations, "", getScopeConfigurationFieldsBy(configurations), values, newShape, language, searchByProducts, searchResults);
        handleCloseModal();
    };

    const isButtonDisabled = () => {
        if (isDecimalDegrees) {
            if (!(latUpperLeft || !lngUpperLeft || !latLowerRight || !lngLowerRight)) return true;
            // logica per controllare latitude e longitude
            return !(
                ((typeLatUpperLeft === translations('sud', language) ? -(parseFloat(latUpperLeft)): +(parseFloat(latUpperLeft))) > (typeLatLowerRight === translations('sud', language) ? -(parseFloat(latLowerRight)) : +(parseFloat(latLowerRight)))) &&
                ((typeLngUpperLeft === translations('ovest', language) ? -(parseFloat(lngUpperLeft)) : +(parseFloat(lngUpperLeft))) < (typeLngLowerRight === translations('ovest', language) ? -(parseFloat(lngLowerRight)) : +(parseFloat(lngLowerRight))))
            );
        } else {
            if ((!degreesXUpperLeft || !minutesXUpperLeft || !secondsXUpperLeft ||
                !degreesYUpperLeft || !minutesYUpperLeft || !secondsYUpperLeft ||
                !degreesXLowerRight || !minutesXLowerRight || !secondsXLowerRight ||
                !degreesYLowerRight || !minutesYLowerRight || !secondsYLowerRight
            )) return true
            // logica per controllare latitude e longitude

            const newLatUpperLeft = convertDegreesMinutesSecondsToDecimal(+degreesYUpperLeft, +minutesYUpperLeft, +secondsYUpperLeft);
            const newLngUpperLeft = convertDegreesMinutesSecondsToDecimal(+degreesXUpperLeft, +minutesXUpperLeft, +secondsXUpperLeft);
            const newLatLowerRight = convertDegreesMinutesSecondsToDecimal(+degreesYLowerRight, +minutesYLowerRight, +secondsYLowerRight);
            const newLngLowerRight = convertDegreesMinutesSecondsToDecimal(+degreesXLowerRight, +minutesXLowerRight, +secondsXLowerRight);

            return !(
                ((typeYUpperLeft === translations('sud', language) ? -newLatUpperLeft : newLatUpperLeft) > (typeYLowerRight === translations('sud', language) ? -newLatLowerRight : newLatLowerRight)) &&
                ((typeXUpperLeft === translations('ovest', language) ? -newLngUpperLeft : newLngUpperLeft) < (typeXLowerRight === translations('ovest', language) ? -newLngLowerRight : newLngLowerRight)));
        }
    };

    return (
        <>
            {isDecimalDegrees ?
                <div className={"row mx-0 mb-3"}>
                    <Card.Subtitle
                        className={'d-flex col-12 mb-3 mt-3  px-0'}>{translations('upperLeft', language)}</Card.Subtitle>
                    <div className={'m-0 px-2 d-flex col-3 mb-3 flex-column'}>
                        <BootstrapForm.Label
                            className={"m-0 px-0"}
                            title="LatUpperLeft">
                      <span>
                        {translations('latitude', language)}
                      </span>
                        </BootstrapForm.Label>
                        <BootstrapForm.Group
                            className={"m-0 pr-0"}>
                            <InputText
                                name="latUpperLeft"
                                onChange={(e) => {
                                    setLatUpperLeft(e.target.value)
                                }}
                                className="m-0 form-control"
                                defaultValue={''}
                                disabled={false}
                                placeholder={translations('upperCornerLatPlaceholder', language)}
                            />
                        </BootstrapForm.Group>
                    </div>
                    <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                        <BootstrapForm.Label
                            className={"m-0 px-0 d-flex pl-3"}
                            title="typeY">
                      <span>
                          &nbsp;
                      </span>
                        </BootstrapForm.Label>
                        <BootstrapForm.Group
                            className={"m-0 pr-0"}>
                            <Picky
                                numberDisplayed={1}
                                options={optionsY}
                                valueKey="value"
                                labelKey="label"
                                keepOpen={false}
                                multiple={false}
                                includeSelectAll={false}
                                value={typeLatUpperLeft}
                                onChange={(e) => {
                                    setTypeLatUpperLeft(e as string)
                                }}
                                dropdownHeight={140}
                                disabled={false}
                            />
                        </BootstrapForm.Group>
                    </div>
                    <div className={'m-0 px-2 d-flex col-3 mb-3 flex-column'}>
                        <BootstrapForm.Label
                            className={"m-0 px-0"}
                            title="LngUpperLeft">
                      <span>
                        {translations('longitude', language)}
                      </span>
                        </BootstrapForm.Label>
                        <BootstrapForm.Group
                            className={"m-0 pr-0"}>
                            <InputText
                                name="lng"
                                onChange={(e) => {
                                    setLngUpperLeft(e.target.value)
                                }}
                                className="m-0 form-control"
                                defaultValue={''}
                                disabled={false}
                                placeholder={translations('upperCornerLngPlaceholder', language)}
                            />
                            {/*<BootstrapForm.Control.Feedback type="invalid">{errorMessage}</BootstrapForm.Control.Feedback>*/}
                        </BootstrapForm.Group>
                    </div>
                    <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                        <BootstrapForm.Label
                            className={"m-0 px-0 d-flex pl-3"}
                            title="typeY">
                      <span>
                          &nbsp;
                      </span>
                        </BootstrapForm.Label>
                        <BootstrapForm.Group
                            className={"m-0 pr-0"}>
                            <Picky
                                numberDisplayed={1}
                                options={optionsX}
                                valueKey="value"
                                labelKey="label"
                                keepOpen={false}
                                multiple={false}
                                includeSelectAll={false}
                                value={typeLngUpperLeft}
                                onChange={(e) => {
                                    setTypeLngUpperLeft(e as string)
                                }}
                                dropdownHeight={140}
                                disabled={false}
                            />
                        </BootstrapForm.Group>
                    </div>
                    <Card.Subtitle
                        className={'d-flex col-12 mb-3 mt-3  px-0'}>{translations('lowerRight', language)}</Card.Subtitle>
                    <div className={'m-0 px-2 d-flex col-3 mb-3 flex-column'}>
                        <BootstrapForm.Label
                            className={"m-0 px-0"}
                            title="latLowerRight">
                      <span>
                        {translations('latitude', language)}
                      </span>
                        </BootstrapForm.Label>
                        <BootstrapForm.Group
                            className={"m-0 pr-0"}>
                            <InputText
                                name="latLowerRight"
                                onChange={(e) => {
                                    setLatLowerRight(e.target.value)
                                }}
                                className="m-0 form-control"
                                defaultValue={''}
                                disabled={false}
                                placeholder={translations('lowerCornerLatPlaceholder', language)}
                            />
                            {/*<BootstrapForm.Control.Feedback type="invalid">{errorMessage}</BootstrapForm.Control.Feedback>*/}
                        </BootstrapForm.Group>
                    </div>
                    <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                        <BootstrapForm.Label
                            className={"m-0 px-0 d-flex pl-3"}
                            title="typeY">
                      <span>
                          &nbsp;
                      </span>
                        </BootstrapForm.Label>
                        <BootstrapForm.Group
                            className={"m-0 pr-0"}>
                            <Picky
                                numberDisplayed={1}
                                options={optionsY}
                                valueKey="value"
                                labelKey="label"
                                keepOpen={false}
                                multiple={false}
                                includeSelectAll={false}
                                value={typeLatLowerRight}
                                onChange={(e) => {
                                    setTypeLatLowerRight(e as string)
                                }}
                                dropdownHeight={140}
                                disabled={false}
                            />
                        </BootstrapForm.Group>
                    </div>
                    <div className={'m-0 px-2 d-flex col-3 mb-3 flex-column'}>
                        <BootstrapForm.Label
                            className={"m-0 px-0"}
                            title="lngLowerRight">
                      <span>
                        {translations('longitude', language)}
                      </span>
                        </BootstrapForm.Label>
                        <BootstrapForm.Group
                            className={"m-0 pr-0"}>
                            <InputText
                                name="lngLowerRight"
                                onChange={(e) => {
                                    setLngLowerRight(e.target.value)
                                }}
                                className="m-0 form-control"
                                defaultValue={''}
                                disabled={false}
                                placeholder={translations('lowerCornerLngPlaceholder', language)}
                            />
                            {/*<BootstrapForm.Control.Feedback type="invalid">{errorMessage}</BootstrapForm.Control.Feedback>*/}
                        </BootstrapForm.Group>
                    </div>
                    <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                        <BootstrapForm.Label
                            className={"m-0 px-0 d-flex pl-3"}
                            title="typeY">
                      <span>
                          &nbsp;
                      </span>
                        </BootstrapForm.Label>
                        <BootstrapForm.Group
                            className={"m-0 pr-0"}>
                            <Picky
                                numberDisplayed={1}
                                options={optionsX}
                                valueKey="value"
                                labelKey="label"
                                keepOpen={false}
                                multiple={false}
                                includeSelectAll={false}
                                value={typeLngLowerRight}
                                onChange={(e) => {
                                    setTypeLngLowerRight(e as string)
                                }}
                                dropdownHeight={140}
                                disabled={false}
                            />
                        </BootstrapForm.Group>
                    </div>
                </div> :
                <>
                    <div className={"row mx-0 mb-3"}>
                        <Card.Subtitle
                            className={'d-flex col-12 mb-3 mt-3  px-0'}>{translations('upperLeft', language)}</Card.Subtitle>
                        <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 "}
                                title="DegY">
                      <span>
                        {translations('degrees', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0"}>
                                <InputText
                                    name="degY"
                                    onChange={(e) => {
                                        setDegreesYUpperLeft(e.target.value)
                                    }}
                                    className="m-0 form-control"
                                    defaultValue={''}
                                    disabled={false}
                                    placeholder={translations('degreesLatPlaceholder', language)}
                                />
                            </BootstrapForm.Group>
                        </div>
                        <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex pl-3"}
                                title="MinY">
                      <span>
                        {translations('minutes', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0 "}>
                                <InputText
                                    name="minY"
                                    onChange={(e) => {
                                        setMinutesYUpperLeft(e.target.value)
                                    }}
                                    className="m-0 form-control"
                                    defaultValue={''}
                                    disabled={false}
                                    placeholder={translations('minutesLatPlaceholder', language)}
                                />
                            </BootstrapForm.Group>
                        </div>
                        <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex"}
                                title="SecY">
                      <span>
                        {translations('seconds', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0"}>
                                <InputText
                                    name="secY"
                                    onChange={(e) => {
                                        setSecondsYUpperLeft(e.target.value)
                                    }}
                                    className="m-0 form-control"
                                    defaultValue={''}
                                    disabled={false}
                                    placeholder={translations('secondsLatPlaceholder', language)}
                                />
                            </BootstrapForm.Group>
                        </div>
                        <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex pl-3"}
                                title="typeY">
                      <span>
                        {translations('latitude', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0"}>
                                <Picky
                                    numberDisplayed={1}
                                    options={optionsY}
                                    valueKey="value"
                                    labelKey="label"
                                    keepOpen={false}
                                    multiple={false}
                                    includeSelectAll={false}
                                    value={typeYUpperLeft}
                                    onChange={(e) => {
                                        setTypeYUpperLeft(e as string)
                                    }}
                                    dropdownHeight={140}
                                    disabled={false}
                                />
                            </BootstrapForm.Group>
                        </div>
                        <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex"}
                                title="DegX">
                      <span>
                        {translations('degrees', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0"}>
                                <InputText
                                    name="degX"
                                    onChange={(e) => {
                                        setDegreesXUpperLeft(e.target.value)
                                    }}
                                    className="m-0 form-control"
                                    defaultValue={''}
                                    disabled={false}
                                    placeholder={translations('degreesLngPlaceholder', language)}
                                />
                            </BootstrapForm.Group>
                        </div>
                        <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex pl-3"}
                                title="MinX">
                      <span>
                        {translations('minutes', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0 "}>
                                <InputText
                                    name="minX"
                                    onChange={(e) => {
                                        setMinutesXUpperLeft(e.target.value)
                                    }}
                                    className="m-0 form-control"
                                    defaultValue={''}
                                    disabled={false}
                                    placeholder={translations('minutesLngPlaceholder', language)}
                                />
                            </BootstrapForm.Group>
                        </div>
                        <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex"}
                                title="SecX">
                      <span>
                        {translations('seconds', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0"}>
                                <InputText
                                    name="secX"
                                    onChange={(e) => {
                                        setSecondsXUpperLeft(e.target.value)
                                    }}
                                    className="m-0 form-control"
                                    defaultValue={''}
                                    disabled={false}
                                    placeholder={translations('secondsLngPlaceholder', language)}
                                />
                            </BootstrapForm.Group>
                        </div>
                        <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex pl-3"}
                                title="typeX">
                      <span>
                        {translations('longitude', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0"}>
                                <Picky
                                    numberDisplayed={1}
                                    options={optionsX}
                                    valueKey="value"
                                    labelKey="label"
                                    keepOpen={false}
                                    multiple={false}
                                    includeSelectAll={false}
                                    value={typeXUpperLeft}
                                    onChange={(e) => {
                                        setTypeXUpperLeft(e as string)
                                    }}
                                    dropdownHeight={140}
                                    disabled={false}
                                />
                            </BootstrapForm.Group>
                        </div>
                    </div>
                    <div className={"row mx-0 mb-3"}>
                        <Card.Subtitle
                            className={'d-flex col-12 mb-3 mt-3  px-0'}>{translations('lowerRight', language)}</Card.Subtitle>
                        <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex"}
                                title="DegY">
                      <span>
                        {translations('degrees', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0"}>
                                <InputText
                                    name="degY"
                                    onChange={(e) => {
                                        setDegreesYLowerRight(e.target.value)
                                    }}
                                    className="m-0 form-control"
                                    defaultValue={''}
                                    disabled={false}
                                    placeholder={translations('degreesLatPlaceholder', language)}
                                />
                            </BootstrapForm.Group>
                        </div>
                        <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex pl-3"}
                                title="MinY">
                      <span>
                        {translations('minutes', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0 "}>
                                <InputText
                                    name="minY"
                                    onChange={(e) => {
                                        setMinutesYLowerRight(e.target.value)
                                    }}
                                    className="m-0 form-control"
                                    defaultValue={''}
                                    disabled={false}
                                    placeholder={translations('minutesLatPlaceholder', language)}
                                />
                            </BootstrapForm.Group>
                        </div>
                        <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex"}
                                title="SecY">
                      <span>
                        {translations('seconds', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0"}>
                                <InputText
                                    name="secY"
                                    onChange={(e) => {
                                        setSecondsYLowerRight(e.target.value)
                                    }}
                                    className="m-0 form-control"
                                    defaultValue={''}
                                    disabled={false}
                                    placeholder={translations('secondsLatPlaceholder', language)}
                                />
                            </BootstrapForm.Group>
                        </div>
                        <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex pl-3"}
                                title="typeY">
                      <span>
                        {translations('latitude', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0"}>
                                <Picky
                                    numberDisplayed={1}
                                    options={optionsY}
                                    valueKey="value"
                                    labelKey="label"
                                    keepOpen={false}
                                    multiple={false}
                                    includeSelectAll={false}
                                    value={typeYLowerRight}
                                    onChange={(e) => {
                                        setTypeYLowerRight(e as string)
                                    }}
                                    dropdownHeight={140}
                                    disabled={false}
                                />
                            </BootstrapForm.Group>
                        </div>
                        <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex"}
                                title="DegX">
                      <span>
                        {translations('degrees', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0"}>
                                <InputText
                                    name="degX"
                                    onChange={(e) => {
                                        setDegreesXLowerRight(e.target.value)
                                    }}
                                    className="m-0 form-control"
                                    defaultValue={''}
                                    disabled={false}
                                    placeholder={translations('degreesLngPlaceholder', language)}
                                />
                            </BootstrapForm.Group>
                        </div>
                        <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex pl-3"}
                                title="MinX">
                      <span>
                        {translations('minutes', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0 "}>
                                <InputText
                                    name="minX"
                                    onChange={(e) => {
                                        setMinutesXLowerRight(e.target.value)
                                    }}
                                    className="m-0 form-control"
                                    defaultValue={''}
                                    disabled={false}
                                    placeholder={translations('minutesLngPlaceholder', language)}
                                />
                            </BootstrapForm.Group>
                        </div>
                        <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex"}
                                title="SecX">
                      <span>
                        {translations('seconds', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0"}>
                                <InputText
                                    name="secX"
                                    onChange={(e) => {
                                        setSecondsXLowerRight(e.target.value)
                                    }}
                                    className="m-0 form-control"
                                    defaultValue={''}
                                    disabled={false}
                                    placeholder={translations('secondsLngPlaceholder', language)}
                                />
                            </BootstrapForm.Group>
                        </div>
                        <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex pl-3"}
                                title="typeX">
                      <span>
                        {translations('longitude', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0"}>
                                <Picky
                                    numberDisplayed={1}
                                    options={optionsX}
                                    valueKey="value"
                                    labelKey="label"
                                    keepOpen={false}
                                    multiple={false}
                                    includeSelectAll={false}
                                    value={typeXLowerRight}
                                    onChange={(e) => {
                                        setTypeXLowerRight(e as string)
                                    }}
                                    dropdownHeight={140}
                                    disabled={false}
                                />
                            </BootstrapForm.Group>
                        </div>
                    </div>
                </>
            }
            <div className={'row'}>
                <div className={'m-0 px-0 d-flex col-12 mb-3 ml-3 switch-container'}>
                    <BootstrapToggle
                        id="circle-degrees"
                        name="circle-degrees"
                        disabled={false}
                        onClick={() => setIsDecimalDegrees(!isDecimalDegrees)}
                        on={translations('rawDegrees', language)}
                        onClassName="mode-switch-routine"
                        off={translations('degMinSec', language)}
                        offClassName="mode-switch-ondemand"
                        handleClassName="container-mode-switch"
                        active={isDecimalDegrees}
                        height="28px"
                        width="190px"
                    />
                </div>
            </div>
            <div className={"row mx-0"}>
                <div className={'m-0 px-0 d-flex col-12'}>
                    <p>{translations('circleCenterToolDisclaimer', language)}</p>
                </div>
            </div>
            <Button onClick={drawSquareHandler} className={"float-right"} disabled={isButtonDisabled()}>
                <span>{translations('done', language)}</span>
            </Button>
        </>
    );
};

const mapStateToProps = (state) => ({
    configurations: state.application.configurations,
    selectedArea: state.geoMap.lastShape,
    values: getSyncSearchFormValuesByState(state),
    language: state.application.appParameters.language,
    searchByProducts: state.geoMap.searchByProducts,
    searchResults: state.product.searchResults
});

const mapDispatchToProps = (dispatch) => ({
    selectNewAreaDispatchActionHandler: (configurations, appParameters, scopeFields, formValues, newShape, language, searchByProducts, searchResults) => dispatch(selectNewAreaDispatchAction(configurations, appParameters, scopeFields, formValues, newShape, language, searchByProducts, searchResults))
});

export default connect(mapStateToProps, mapDispatchToProps)(SquareAOIHelper);
